import { create } from "zustand";
import { persist } from "zustand/middleware";

const useGRIStore = create(
  persist(
    (set) => ({
      selectedGRI: null,
      setSelectedGRI: (id) => set({ selectedGRI: id }),
      reset: () => set({ selectedGRI: null }),
    }),
    {
      name: "auth-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useGRIStore;
